import Controller, { OnClick } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController';
import { FragmentNames, PatientTransferConfirmationAliases } from '../../codegen';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';

@Controller({ component: PatientTransferConfirmationAliases.LAYOUT_MAIN, fragment: FragmentNames.PATIENT_TRANSFER_CONFIRMATION })
class PatientTransferConfirmationController extends BaseController {

  @OnClick({target: PatientTransferConfirmationAliases.BUTTON_FINALIZAR })
  onButtonClick(): void {
    applicationContext.popNavigationItem();
  }
}

export default PatientTransferConfirmationController;
